import { createFileRoute } from "@tanstack/react-router";
import { BrasilChannelLanding } from "@/components/match/brasil/BrasilChannelLanding";
import { BRASIL_FAQ_BY_CHANNEL, buildFaqJsonLd } from "@/components/growth/BrasilFaq";

export const Route = createFileRoute("/brasil/globo")({
  head: () => ({
    meta: [
      { title: "VerseSport Brasil + TV Globo — Segunda tela da torcida" },
      { name: "description", content: "Acompanhe a transmissão da TV Globo com a segunda tela do VerseSport: previsões em tempo real, ranking da torcida e Audio Sync." },
      { property: "og:title", content: "VerseSport Brasil + TV Globo — Segunda tela da torcida" },
      { property: "og:description", content: "Acompanhe a transmissão da TV Globo com a segunda tela do VerseSport: previsões em tempo real, ranking da torcida e Audio Sync." },
      { property: "og:url", content: "https://versesport.com/brasil/globo" },
      { property: "og:type", content: "website" },
    ],
    links: [{ rel: "canonical", href: "https://versesport.com/brasil/globo" }],
    scripts: [{ type: "application/ld+json", children: JSON.stringify(buildFaqJsonLd(BRASIL_FAQ_BY_CHANNEL.globo)) }],
  }),
  component: () => (
    <BrasilChannelLanding channelId="globo" channelName="TV Globo" intro="Segunda tela oficial para a torcida que assiste à TV Globo: previsões, estatísticas e Nation Wars." />
  ),
});
